export default {"src":"/_next/static/media/supporter.3eebfbd7.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};